module.exports = __webpack_public_path__ + "fonts/silka-regular.badc42e2.ttf";